import { SET_SERVICE_CODE_ID } from 'actions';

export function setServiceCodeId(serviceCodeId?: string) {
  return { serviceCodeId, type: SET_SERVICE_CODE_ID };
}
